import Vue from 'vue'
import axios from 'axios'
// import _ from 'lodash'

const vueObj = new Vue()

const state = {
  conversations: null,
  // true ระหว่างโหลดหน้าแรกของรายการ — ให้การ์ดแสดง "กำลังโหลด" แทน "ไม่พบบทสนทนา"
  conversationsLoading: false,
  conversation: null,
  selectedAdmin: null,
  // v2026 multi-select. `selectedAdmin` (singular) is still what SearchConversation.vue and
  // MainMenu.vue read, so it stays — the two are independent, not two views of one value.
  selectedAdmins: [],
  customer: null,
  notes: [],
  customerType: 'customer',
  // Inbox order chosen by the admin (see INBOX_SORTS). The store is persisted to localStorage, so it survives reloads.
  inboxSort: 'waiting_asc'
}

// เลขรอบของการโหลดรายการหน้าแรก — สลับเมนูเร็ว ๆ แล้ว response ของเมนูก่อนหน้ากลับมาทีหลัง
// ต้องทิ้ง ไม่งั้นทับรายการของเมนูปัจจุบัน (เช่น ไป "ปิดเคส" แล้วกลับ "รับเคสแล้ว" ทันที)
let conversationListRequestId = 0

const actions = {
  fetchConversations: async ({ commit, state }, queryParams) => {
    if (queryParams.page === 0) {
      conversationListRequestId += 1
      commit('SET_CONVERSATIONS', [])
      commit('SET_CONVERSATIONS_LOADING', true)
    }
    // load more ก็ผูกกับรอบเดียวกัน — ถ้าเริ่มโหลดหน้าแรกใหม่ระหว่างรอ หน้าถัดไปของรอบเก่าต้องทิ้งด้วย
    const requestId = conversationListRequestId
    const page = queryParams.page
    const url = '/conversations'
    const config = {}
    if (queryParams) config.params = withInboxSort(queryParams, state.inboxSort)
    try {
      const res = await axios.get(url, config)
      if (requestId !== conversationListRequestId) {
        return
      }
      const conversations = res.data.conversations
      if (res.status === 200 && conversations.length) {
        if (page === 0) {
          commit('SET_CONVERSATIONS', conversations)
        } else {
          commit('SET_MORE_CONVERSATIONS', conversations)
        }
      } else {
        console.log('error', res.data)
      }
    } catch (e) {
      if (page === 0 && requestId === conversationListRequestId) {
        commit('SET_CONVERSATIONS', [])
      }
    } finally {
      // รอบเก่าที่ถูกทิ้งห้ามปิด loading ของรอบใหม่
      if (page === 0 && requestId === conversationListRequestId) {
        commit('SET_CONVERSATIONS_LOADING', false)
      }
    }
  },
  closeConversation: async ({ commit, rootState }, payload) => {
    commit('SET_CONVERSATION', null)
    commit('SET_CUSTOMER', null)
    commit('message/SET_MESSAGES', [], { root: true })
    const res = await axios.post(`/admins/${payload.admin_id}/close-conversation`, {
      conversation_id: payload.conversation_id || null
    })
    if (res.status !== 200) {
      vueObj.$swal({ text: res.data.error })
    }
  },
  fetchConversation: async ({ commit }, payload) => {
    commit('SET_CONVERSATION', null)
    const url = `/conversations/${payload.id}`
    const res = await axios.get(url, { params: payload.queryParams })
    if (res.status === 200) {
      const conversation = res.data
      commit('SET_CONVERSATION', conversation)
    } else {
      vueObj.$swal({ text: res.data.error })
    }
  },
  fetchConversationCustomers: async ({ commit }, params) => {
    commit('SET_CONVERSATIONS', [])
    const url = `/conversations/customers`
    const res = await axios.get(url, { params })
    if (res.status === 200) {
      console.log('check res', res)
      const conversations = res.data.conversations
      commit('SET_CONVERSATIONS', conversations)
    } else {
      vueObj.$swal({ text: res.data.error })
    }
  },
  searchCustomer: async ({ commit, rootState }, params) => {
    // TODO: Implement token based authentication
    commit('SET_CONVERSATION', null)
    commit('SET_CUSTOMER', null)
    try {
      /* const url = `https://lumen-admin.beneat.co/search-user`
      const res = await axios.get(url, { params, withCredentials: false }) */
      const url = `/search-user`
      const res = await axios.get(url, { params })
      if (res.status === 200) {
        const customer = res.data
        commit('SET_CUSTOMER', customer)
      } else {
        vueObj.$swal({ text: res.data.error })
      }
    } catch (err) {
      let { data } = err.response
      let message = data.message
      if (data.message !== 'Not Found') {
        vueObj.$swal({ text: message })
      }
    }
  },
  fetchNotes: async ({ commit }, payload) => {
    // TODO: Implement token based authentication
    commit('SET_NOTES', null)
    const userType = payload.profile_type
    try {
      const res = await axios.get(payload.url, { params: payload.params, withCredentials: false })
      if (userType === 'customer') {
        if (res.status === 200) {
          const notes = res.data.data
          commit('SET_NOTES', notes)
        } else {
          vueObj.$swal({ text: res.data.error })
        }
      } else if (userType === 'professional') {
        if (res.status === 200) {
          const notes = res.data.data
          commit('SET_NOTES', notes)
        } else {
          vueObj.$swal({ text: res.data.error })
        }
      } else if (userType === 'applicant') {
        if (res.status === 200) {
          const notes = res.data.notes
          commit('SET_NOTES', notes)
        } else {
          vueObj.$swal({ text: res.data.error })
        }
      }
    } catch (err) {
      let { data } = err.response
      data = data || err
      vueObj.$swal({ text: data.message })
    }
  },
  updateConversation: async ({ commit }, submitData) => {
    const url = `/conversations/${submitData.id}`
    await axios.put(url, submitData)
  }
}

// ลำดับรายการแชท — ต้องตรงกับ ORDER BY ฝั่ง server (chat-server/helpers/conversationHelper.js)
// COALESCE(last_active_at, start_conversation_at, created_at) DESC, id DESC
const listOrderTime = (conversation) => {
  const value = conversation.last_active_at || conversation.start_conversation_at || conversation.created_at
  const time = value ? new Date(value).getTime() : 0
  return Number.isNaN(time) ? 0 : time
}
// < 0 = a อยู่เหนือ b
const compareListOrder = (a, b) => {
  const diff = listOrderTime(b) - listOrderTime(a)
  return diff !== 0 ? diff : Number(b.id) - Number(a.id)
}

// Inbox sort options — must match INBOX_SORTS on the server (chat-server/helpers/conversationHelper.js).
// waiting = COALESCE(start_conversation_at, created_at), latest = listOrderTime; id breaks ties in the same direction.
const waitingOrderTime = (conversation) => {
  const value = conversation.start_conversation_at || conversation.created_at
  const time = value ? new Date(value).getTime() : 0
  return Number.isNaN(time) ? 0 : time
}
const INBOX_SORTS = {
  waiting_asc: { orderTime: waitingOrderTime, direction: 1 },
  waiting_desc: { orderTime: waitingOrderTime, direction: -1 },
  latest_desc: { orderTime: listOrderTime, direction: -1 },
  latest_asc: { orderTime: listOrderTime, direction: 1 }
}
const DEFAULT_INBOX_SORT = 'waiting_asc'
const resolveInboxSort = (inboxSort) => Object.prototype.hasOwnProperty.call(INBOX_SORTS, inboxSort) ? inboxSort : DEFAULT_INBOX_SORT
// Only the inbox sends inbox_sort; other menus keep their fixed order.
export const withInboxSort = (params, inboxSort) => params && params.menu === 'inbox'
  ? { ...params, inbox_sort: resolveInboxSort(inboxSort) }
  : params
const compareInboxOrder = (inboxSort) => {
  const { orderTime, direction } = INBOX_SORTS[resolveInboxSort(inboxSort)]
  return (a, b) => {
    const diff = orderTime(a) - orderTime(b)
    return direction * (diff !== 0 ? diff : Number(a.id) - Number(b.id))
  }
}
// หน้าละ 20 (GET /conversations) — หน้าสุดท้ายที่ได้มาไม่เต็ม = โหลดครบแล้ว
const CONVERSATION_PAGE_SIZE = 20

const mutations = {
  SET_CONVERSATIONS_LOADING: (state, value) => {
    state.conversationsLoading = value
  },
  SET_CONVERSATIONS: (state, conversations) => {
    state.conversations = conversations
  },
  SET_MORE_CONVERSATIONS: (state, conversations) => {
    // offset paging บนลำดับที่ขยับตลอด — แถวที่เลื่อนขึ้นระหว่างโหลดหน้าจะถูกส่งมาซ้ำ
    const loadedIds = new Set(state.conversations.map(item => item.id))
    state.conversations = [...state.conversations, ...conversations.filter(item => !loadedIds.has(item.id))]
  },
  SET_CONVERSATION: (state, conversation) => {
    state.conversation = conversation
  },
  SET_CUSTOMER: (state, customer) => {
    state.customer = customer
  },
  SET_NOTES: (state, notes) => {
    state.notes = notes
  },
  SET_INBOX_SORT: (state, inboxSort) => {
    state.inboxSort = resolveInboxSort(inboxSort)
  },
  // ลำดับต้องตรงกับ ORDER BY ฝั่ง server (chat-server/helpers/conversationHelper.js — buildConversationQueryOptions)
  // Inbox follows inboxSort; other menus put the most recent activity first (last_active_at).
  UPDATE_LAST_MESSAGE: (state, { conversation, message = null, menuType, admin = null, hasAdminFilter = false }) => {
    const index = state.conversations.findIndex(item => item.id === conversation.id)

    // เช็คว่าบทสนทนามี customer type อยู่ในสิทธิ์ของ admin — admin ที่ไม่ได้จำกัด customer_types เห็นได้ทุกประเภท
    const adminCustomerTypes = admin && admin.customer_types && admin.customer_types.types && admin.customer_types.types.length > 0 ? admin.customer_types.types : null
    const isAllowed = !adminCustomerTypes || !conversation.customer_type || adminCustomerTypes.indexOf(conversation.customer_type) > -1
    // มีคนรับเคสแล้วต้องไม่แสดงใน inbox — ยกเว้นตอนกรองด้วยแอดมิน (ตัวกรองทับ admin_id ของเมนู ดู getAdminIdWhere)
    const isAssignedInInbox = menuType === 'inbox' && !hasAdminFilter && !!conversation.admin
    if (!isAllowed || isAssignedInInbox) {
      if (index > -1) {
        state.conversations.splice(index, 1)
      }
      return
    }

    // Position by the timestamps the server just wrote (customer, admin and bot messages all bump last_active_at).
    // Do not infer the sender here: the socket payload carries the same values ORDER BY uses, so the order always matches.
    // Waiting-based modes do not change on a new message, so the card returns to its previous slot.
    const compare = menuType === 'inbox' ? compareInboxOrder(state.inboxSort) : compareListOrder
    if (index > -1) {
      state.conversations.splice(index, 1)
    }
    const insertAt = state.conversations.findIndex(item => compare(conversation, item) < 0)
    if (insertAt > -1) {
      state.conversations.splice(insertAt, 0, conversation)
    } else if (index > -1 || state.conversations.length === 0 || state.conversations.length % CONVERSATION_PAGE_SIZE !== 0) {
      // เก่ากว่าทุกแถวที่โหลดไว้: เคยอยู่ในรายการ หรือโหลดครบแล้ว ต่อท้ายได้ — ไม่งั้นปล่อยให้ load more ดึงมาเอง
      state.conversations.push(conversation)
    }
  },
  UPDATE_CONVERSATION: (state, conversation) => {
    for (let key in state.conversations) {
      if (conversation && state.conversations[key].id === conversation.id) {
        state.conversations[key] = conversation
        break
      }
    }
    state.conversations = [...state.conversations]
  },
  REMOVE_CONVERSATION_FROM_LIST: (state, conversationId) => {
    for (let key in state.conversations) {
      if (state.conversations[key].id === conversationId) {
        state.conversations.splice(key, 1)
        break
      }
    }
  },
  SET_SELECTED_ADMIN: (state, admin) => {
    state.selectedAdmin = admin
  },
  SET_SELECTED_ADMINS: (state, admins) => {
    state.selectedAdmins = Array.isArray(admins) ? admins : []
  },
  SET_CUSTOMER_TYPE: (state, customerType) => {
    state.customerType = customerType
  },
  SET_IS_READ: (state, conversationId) => {
    for (let key in state.conversations) {
      if (state.conversations[key].id === conversationId) {
        state.conversations[key].is_read = 1
        state.conversations[key].unread_count = 0
        break
      }
    }
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
